// Feedback #510 — shared hook that fetches the firm's practice areas.
// Cached on window.__lextrackPracticeAreas so multiple pages don't re-fetch.
// Invalidated when Settings > Practice Areas admin CRUD fires an event.

import { useEffect, useState } from 'react'
import api from '../services/api'

export default function useFirmPracticeAreas () {
  const [areas, setAreas] = useState(() => window.__lextrackPracticeAreas || [])
  const [loading, setLoading] = useState(!window.__lextrackPracticeAreas)

  useEffect(() => {
    let cancelled = false
    async function load () {
      try {
        const r = await api.get('/api/practice-areas')
        if (cancelled) return
        window.__lextrackPracticeAreas = r.data || []
        setAreas(window.__lextrackPracticeAreas)
      } catch { /* fall back to whatever is cached */ } finally {
        if (!cancelled) setLoading(false)
      }
    }
    if (!window.__lextrackPracticeAreas) load()
    // Refresh on admin-fired event so Settings > Practice Areas CRUD flows.
    const onRefresh = () => {
      window.__lextrackPracticeAreas = null
      load()
    }
    window.addEventListener('lextrack-practice-areas-changed', onRefresh)
    return () => {
      cancelled = true
      window.removeEventListener('lextrack-practice-areas-changed', onRefresh)
    }
  }, [])

  return { areas, loading }
}
